export const SET_MENU = "SET_MENU";
export const SET_ACTIVE_MENU = 'SET_ACTIVE_MENU';
export const GET_MENU = "GET_MENU";